module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "requests-table"
  }, [_c('div', {
    staticClass: "table-toolbar"
  }, [_c('button', {
    staticClass: "btn btn-icon",
    on: {
      "click": _vm.download
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-icon",
    on: {
      "click": function($event) {
        _vm.showColumnPicker = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-columns"
  })])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "wrapper small",
    attrs: {
      "id": "wrapper"
    }
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-hover table-striped policies-table"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _vm._l((_vm.pickedColumns), function(c) {
    return _c('th', [_vm._v("\n                " + _vm._s(c.name) + "\n              ")])
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.rows), function(row) {
    return _c('tr', {
      key: row.id
    }, [_c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "btn btn-link",
      on: {
        "click": function($event) {
          return _vm.showDetails(row.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-info",
      staticStyle: {
        "padding-right": "0"
      }
    })])]), _vm._v(" "), _vm._l((row.fields), function(field) {
      return _c('td', [_vm._v("\n                  " + _vm._s(field) + "\n              ")])
    })], 2)
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "ls-table-pagination"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.previous == 0 || _vm.loading
    },
    on: {
      "click": function($event) {
        _vm.page--
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _vm._v(" prev")]), _vm._v(" | \n        "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.next == 0 || _vm.loading
    },
    on: {
      "click": function($event) {
        _vm.page++
      }
    }
  }, [_vm._v("next "), _c('i', {
    staticClass: "fa fa-arrow-right"
  })])])])]), _vm._v(" "), (_vm.showColumnPicker) ? _c('columns-picker-modal', {
    attrs: {
      "availableColumns": _vm.columns
    },
    on: {
      "close": function($event) {
        _vm.showColumnPicker = false
      },
      "setColumns": _vm.savePickedColumns
    }
  }) : _vm._e(), _vm._v(" "), (_vm.clientRecord) ? _c('epic-client-modal', {
    attrs: {
      "client": _vm.clientRecord
    },
    on: {
      "close": function($event) {
        _vm.clientRecord = null
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-677aa025"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/EpicClientsTable.vue
// module id = 657
// module chunks = 0